import type { SVGProps } from 'react';

/** Icône au trait (couleur du texte) de Mon compte : on ne fournit que les tracés. */
export function Svg(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            {...props}
        />
    );
}
